module.exports = __webpack_public_path__ + "img/c-bg3.706650fb.jpg";